// vendor

import Swiper, {
  Navigation, Pagination, EffectFade, Autoplay, Thumbs,
} from 'swiper/core';

// components
import ScrollSection from './partials/scrollSection';
import Slider from './partials/slider';
import Reviews from './partials/reviews';

// configure Swiper to use modules
Swiper.use([Navigation, Pagination, EffectFade, Autoplay, Thumbs]);

class Jobs {
  constructor() {
    this.dom = {
      scrollSection: document.getElementById('jobs-about-scroll'),
      widgetSlider: document.querySelector('.w-slider .swiper-container'),
      reviewsSlider: document.querySelector('.reviews-slider'),
      reviewsPeopleSlider: document.querySelector('.reviews-people-slider'),
    };

    this.components = {
      scrollSection: null,
      widgetSlider: null,
      reviewsSlider: null,
    };
  }

  mount() {
    // services actions
    if (this.dom.scrollSection && !window.location.hash) {
      // this.components.services = new PinnedListWithImages(this.dom.services);
      setTimeout(() => {
        this.components.scrollSection = new ScrollSection(this.dom.scrollSection);
      }, 100);
    }

    // init widget swiper
    if (this.dom.widgetSlider) {
      setTimeout(() => {
        this.components.widgetSlider = new Slider(this.dom.widgetSlider);
      }, 500);
    }

    // init review swiper
    if (this.dom.reviewsSlider && this.dom.reviewsPeopleSlider) {
      setTimeout(() => {
        this.components.reviewsSlider = new Reviews(this.dom.reviewsSlider, this.dom.reviewsPeopleSlider);
      }, 100);
    }
  }
}

if (document.getElementById('page-jobs-overview')) {
  new Jobs().mount();
}
